import type { PageLoad } from './$types';
import { buildSeoMeta } from '$lib/seo';
import { serializeSchema } from '$lib/jsonld';
import { faqGeneral as categories } from '$lib/data/faq';

export const prerender = true;

export const load: PageLoad = ({ url }) => {
	return {
		seo: buildSeoMeta({
			type: 'home',
			title: 'FAQ – Juslin.dev | Questions fréquentes',
			url: url.href,
			description:
				'Retrouvez les réponses aux questions les plus fréquentes sur les services, produits digitaux, tarifs et la collaboration avec Juslin.'
		}),
		jsonld: serializeSchema({
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: categories.flatMap((cat) =>
				cat.questions.map((item) => ({
					'@type': 'Question',
					name: item.q,
					acceptedAnswer: {
						'@type': 'Answer',
						text: item.a
					}
				}))
			)
		})
	};
};
